/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AuthSignupImport } from './routes/_auth/signup'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AppHomeImport } from './routes/_app/home'
import { Route as AppAccountIndexImport } from './routes/_app/account/index'
import { Route as AppRecipesListImport } from './routes/_app/recipes/_list'
import { Route as AppAccountEditImport } from './routes/_app/account/edit'
import { Route as AppRecipesListIndexImport } from './routes/_app/recipes/_list/index'
import { Route as AppAccountSettingsIndexImport } from './routes/_app/account/settings/index'
import { Route as AppRecipesListExploreImport } from './routes/_app/recipes/_list/explore'
import { Route as AppAccountSettingsLayoutImport } from './routes/_app/account/settings/_layout'
import { Route as AppAccountSettingsLayoutRecipesImport } from './routes/_app/account/settings/_layout/recipes'
import { Route as AppAccountSettingsLayoutGeneralImport } from './routes/_app/account/settings/_layout/general'
import { Route as AppAccountSettingsLayoutDrinksImport } from './routes/_app/account/settings/_layout/drinks'

// Create Virtual Routes

const AppRecipesImport = createFileRoute('/_app/recipes')()
const AppAccountSettingsImport = createFileRoute('/_app/account/settings')()
const AppMyBarIndexLazyImport = createFileRoute('/_app/my-bar/')()
const AppRecipesNewLazyImport = createFileRoute('/_app/recipes/new')()
const AppRecipesSlugIndexLazyImport = createFileRoute('/_app/recipes/$slug/')()
const AppRecipesSlugEditLazyImport = createFileRoute(
  '/_app/recipes/$slug/edit',
)()

// Create/Update Routes

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppRecipesRoute = AppRecipesImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => AppRoute,
} as any)

const AuthSignupRoute = AuthSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AppHomeRoute = AppHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountSettingsRoute = AppAccountSettingsImport.update({
  id: '/account/settings',
  path: '/account/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppMyBarIndexLazyRoute = AppMyBarIndexLazyImport.update({
  id: '/my-bar/',
  path: '/my-bar/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/my-bar/index.lazy').then((d) => d.Route),
)

const AppAccountIndexRoute = AppAccountIndexImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRoute,
} as any)

const AppRecipesNewLazyRoute = AppRecipesNewLazyImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRecipesRoute,
} as any).lazy(() =>
  import('./routes/_app/recipes/new.lazy').then((d) => d.Route),
)

const AppRecipesListRoute = AppRecipesListImport.update({
  id: '/_list',
  getParentRoute: () => AppRecipesRoute,
} as any)

const AppAccountEditRoute = AppAccountEditImport.update({
  id: '/account/edit',
  path: '/account/edit',
  getParentRoute: () => AppRoute,
} as any)

const AppRecipesSlugIndexLazyRoute = AppRecipesSlugIndexLazyImport.update({
  id: '/$slug/',
  path: '/$slug/',
  getParentRoute: () => AppRecipesRoute,
} as any).lazy(() =>
  import('./routes/_app/recipes/$slug.index.lazy').then((d) => d.Route),
)

const AppRecipesListIndexRoute = AppRecipesListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRecipesListRoute,
} as any).lazy(() =>
  import('./routes/_app/recipes/_list/index.lazy').then((d) => d.Route),
)

const AppAccountSettingsIndexRoute = AppAccountSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountSettingsRoute,
} as any)

const AppRecipesSlugEditLazyRoute = AppRecipesSlugEditLazyImport.update({
  id: '/$slug/edit',
  path: '/$slug/edit',
  getParentRoute: () => AppRecipesRoute,
} as any).lazy(() =>
  import('./routes/_app/recipes/$slug.edit.lazy').then((d) => d.Route),
)

const AppRecipesListExploreRoute = AppRecipesListExploreImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AppRecipesListRoute,
} as any)

const AppAccountSettingsLayoutRoute = AppAccountSettingsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAccountSettingsRoute,
} as any)

const AppAccountSettingsLayoutRecipesRoute =
  AppAccountSettingsLayoutRecipesImport.update({
    id: '/recipes',
    path: '/recipes',
    getParentRoute: () => AppAccountSettingsLayoutRoute,
  } as any)

const AppAccountSettingsLayoutGeneralRoute =
  AppAccountSettingsLayoutGeneralImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AppAccountSettingsLayoutRoute,
  } as any)

const AppAccountSettingsLayoutDrinksRoute =
  AppAccountSettingsLayoutDrinksImport.update({
    id: '/drinks',
    path: '/drinks',
    getParentRoute: () => AppAccountSettingsLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeImport
      parentRoute: typeof AppImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof AuthImport
    }
    '/_app/account/edit': {
      id: '/_app/account/edit'
      path: '/account/edit'
      fullPath: '/account/edit'
      preLoaderRoute: typeof AppAccountEditImport
      parentRoute: typeof AppImport
    }
    '/_app/recipes': {
      id: '/_app/recipes'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof AppRecipesImport
      parentRoute: typeof AppImport
    }
    '/_app/recipes/_list': {
      id: '/_app/recipes/_list'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof AppRecipesListImport
      parentRoute: typeof AppRecipesRoute
    }
    '/_app/recipes/new': {
      id: '/_app/recipes/new'
      path: '/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof AppRecipesNewLazyImport
      parentRoute: typeof AppRecipesImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/my-bar/': {
      id: '/_app/my-bar/'
      path: '/my-bar'
      fullPath: '/my-bar'
      preLoaderRoute: typeof AppMyBarIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/account/settings': {
      id: '/_app/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AppAccountSettingsImport
      parentRoute: typeof AppImport
    }
    '/_app/account/settings/_layout': {
      id: '/_app/account/settings/_layout'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AppAccountSettingsLayoutImport
      parentRoute: typeof AppAccountSettingsRoute
    }
    '/_app/recipes/_list/explore': {
      id: '/_app/recipes/_list/explore'
      path: '/explore'
      fullPath: '/recipes/explore'
      preLoaderRoute: typeof AppRecipesListExploreImport
      parentRoute: typeof AppRecipesListImport
    }
    '/_app/recipes/$slug/edit': {
      id: '/_app/recipes/$slug/edit'
      path: '/$slug/edit'
      fullPath: '/recipes/$slug/edit'
      preLoaderRoute: typeof AppRecipesSlugEditLazyImport
      parentRoute: typeof AppRecipesImport
    }
    '/_app/account/settings/': {
      id: '/_app/account/settings/'
      path: '/'
      fullPath: '/account/settings/'
      preLoaderRoute: typeof AppAccountSettingsIndexImport
      parentRoute: typeof AppAccountSettingsImport
    }
    '/_app/recipes/_list/': {
      id: '/_app/recipes/_list/'
      path: '/'
      fullPath: '/recipes/'
      preLoaderRoute: typeof AppRecipesListIndexImport
      parentRoute: typeof AppRecipesListImport
    }
    '/_app/recipes/$slug/': {
      id: '/_app/recipes/$slug/'
      path: '/$slug'
      fullPath: '/recipes/$slug'
      preLoaderRoute: typeof AppRecipesSlugIndexLazyImport
      parentRoute: typeof AppRecipesImport
    }
    '/_app/account/settings/_layout/drinks': {
      id: '/_app/account/settings/_layout/drinks'
      path: '/drinks'
      fullPath: '/account/settings/drinks'
      preLoaderRoute: typeof AppAccountSettingsLayoutDrinksImport
      parentRoute: typeof AppAccountSettingsLayoutImport
    }
    '/_app/account/settings/_layout/general': {
      id: '/_app/account/settings/_layout/general'
      path: '/general'
      fullPath: '/account/settings/general'
      preLoaderRoute: typeof AppAccountSettingsLayoutGeneralImport
      parentRoute: typeof AppAccountSettingsLayoutImport
    }
    '/_app/account/settings/_layout/recipes': {
      id: '/_app/account/settings/_layout/recipes'
      path: '/recipes'
      fullPath: '/account/settings/recipes'
      preLoaderRoute: typeof AppAccountSettingsLayoutRecipesImport
      parentRoute: typeof AppAccountSettingsLayoutImport
    }
  }
}

// Create and export the route tree

interface AppRecipesListRouteChildren {
  AppRecipesListExploreRoute: typeof AppRecipesListExploreRoute
  AppRecipesListIndexRoute: typeof AppRecipesListIndexRoute
}

const AppRecipesListRouteChildren: AppRecipesListRouteChildren = {
  AppRecipesListExploreRoute: AppRecipesListExploreRoute,
  AppRecipesListIndexRoute: AppRecipesListIndexRoute,
}

const AppRecipesListRouteWithChildren = AppRecipesListRoute._addFileChildren(
  AppRecipesListRouteChildren,
)

interface AppRecipesRouteChildren {
  AppRecipesListRoute: typeof AppRecipesListRouteWithChildren
  AppRecipesNewLazyRoute: typeof AppRecipesNewLazyRoute
  AppRecipesSlugEditLazyRoute: typeof AppRecipesSlugEditLazyRoute
  AppRecipesSlugIndexLazyRoute: typeof AppRecipesSlugIndexLazyRoute
}

const AppRecipesRouteChildren: AppRecipesRouteChildren = {
  AppRecipesListRoute: AppRecipesListRouteWithChildren,
  AppRecipesNewLazyRoute: AppRecipesNewLazyRoute,
  AppRecipesSlugEditLazyRoute: AppRecipesSlugEditLazyRoute,
  AppRecipesSlugIndexLazyRoute: AppRecipesSlugIndexLazyRoute,
}

const AppRecipesRouteWithChildren = AppRecipesRoute._addFileChildren(
  AppRecipesRouteChildren,
)

interface AppAccountSettingsLayoutRouteChildren {
  AppAccountSettingsLayoutDrinksRoute: typeof AppAccountSettingsLayoutDrinksRoute
  AppAccountSettingsLayoutGeneralRoute: typeof AppAccountSettingsLayoutGeneralRoute
  AppAccountSettingsLayoutRecipesRoute: typeof AppAccountSettingsLayoutRecipesRoute
}

const AppAccountSettingsLayoutRouteChildren: AppAccountSettingsLayoutRouteChildren =
  {
    AppAccountSettingsLayoutDrinksRoute: AppAccountSettingsLayoutDrinksRoute,
    AppAccountSettingsLayoutGeneralRoute: AppAccountSettingsLayoutGeneralRoute,
    AppAccountSettingsLayoutRecipesRoute: AppAccountSettingsLayoutRecipesRoute,
  }

const AppAccountSettingsLayoutRouteWithChildren =
  AppAccountSettingsLayoutRoute._addFileChildren(
    AppAccountSettingsLayoutRouteChildren,
  )

interface AppAccountSettingsRouteChildren {
  AppAccountSettingsLayoutRoute: typeof AppAccountSettingsLayoutRouteWithChildren
  AppAccountSettingsIndexRoute: typeof AppAccountSettingsIndexRoute
}

const AppAccountSettingsRouteChildren: AppAccountSettingsRouteChildren = {
  AppAccountSettingsLayoutRoute: AppAccountSettingsLayoutRouteWithChildren,
  AppAccountSettingsIndexRoute: AppAccountSettingsIndexRoute,
}

const AppAccountSettingsRouteWithChildren =
  AppAccountSettingsRoute._addFileChildren(AppAccountSettingsRouteChildren)

interface AppRouteChildren {
  AppHomeRoute: typeof AppHomeRoute
  AppAccountEditRoute: typeof AppAccountEditRoute
  AppRecipesRoute: typeof AppRecipesRouteWithChildren
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppMyBarIndexLazyRoute: typeof AppMyBarIndexLazyRoute
  AppAccountSettingsRoute: typeof AppAccountSettingsRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppHomeRoute: AppHomeRoute,
  AppAccountEditRoute: AppAccountEditRoute,
  AppRecipesRoute: AppRecipesRouteWithChildren,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppMyBarIndexLazyRoute: AppMyBarIndexLazyRoute,
  AppAccountSettingsRoute: AppAccountSettingsRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/home': typeof AppHomeRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/account/edit': typeof AppAccountEditRoute
  '/recipes': typeof AppRecipesListRouteWithChildren
  '/recipes/new': typeof AppRecipesNewLazyRoute
  '/account': typeof AppAccountIndexRoute
  '/my-bar': typeof AppMyBarIndexLazyRoute
  '/account/settings': typeof AppAccountSettingsLayoutRouteWithChildren
  '/recipes/explore': typeof AppRecipesListExploreRoute
  '/recipes/$slug/edit': typeof AppRecipesSlugEditLazyRoute
  '/account/settings/': typeof AppAccountSettingsIndexRoute
  '/recipes/': typeof AppRecipesListIndexRoute
  '/recipes/$slug': typeof AppRecipesSlugIndexLazyRoute
  '/account/settings/drinks': typeof AppAccountSettingsLayoutDrinksRoute
  '/account/settings/general': typeof AppAccountSettingsLayoutGeneralRoute
  '/account/settings/recipes': typeof AppAccountSettingsLayoutRecipesRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/home': typeof AppHomeRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/account/edit': typeof AppAccountEditRoute
  '/recipes': typeof AppRecipesListIndexRoute
  '/recipes/new': typeof AppRecipesNewLazyRoute
  '/account': typeof AppAccountIndexRoute
  '/my-bar': typeof AppMyBarIndexLazyRoute
  '/account/settings': typeof AppAccountSettingsIndexRoute
  '/recipes/explore': typeof AppRecipesListExploreRoute
  '/recipes/$slug/edit': typeof AppRecipesSlugEditLazyRoute
  '/recipes/$slug': typeof AppRecipesSlugIndexLazyRoute
  '/account/settings/drinks': typeof AppAccountSettingsLayoutDrinksRoute
  '/account/settings/general': typeof AppAccountSettingsLayoutGeneralRoute
  '/account/settings/recipes': typeof AppAccountSettingsLayoutRecipesRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/home': typeof AppHomeRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_app/account/edit': typeof AppAccountEditRoute
  '/_app/recipes': typeof AppRecipesRouteWithChildren
  '/_app/recipes/_list': typeof AppRecipesListRouteWithChildren
  '/_app/recipes/new': typeof AppRecipesNewLazyRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/my-bar/': typeof AppMyBarIndexLazyRoute
  '/_app/account/settings': typeof AppAccountSettingsRouteWithChildren
  '/_app/account/settings/_layout': typeof AppAccountSettingsLayoutRouteWithChildren
  '/_app/recipes/_list/explore': typeof AppRecipesListExploreRoute
  '/_app/recipes/$slug/edit': typeof AppRecipesSlugEditLazyRoute
  '/_app/account/settings/': typeof AppAccountSettingsIndexRoute
  '/_app/recipes/_list/': typeof AppRecipesListIndexRoute
  '/_app/recipes/$slug/': typeof AppRecipesSlugIndexLazyRoute
  '/_app/account/settings/_layout/drinks': typeof AppAccountSettingsLayoutDrinksRoute
  '/_app/account/settings/_layout/general': typeof AppAccountSettingsLayoutGeneralRoute
  '/_app/account/settings/_layout/recipes': typeof AppAccountSettingsLayoutRecipesRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/home'
    | '/login'
    | '/signup'
    | '/account/edit'
    | '/recipes'
    | '/recipes/new'
    | '/account'
    | '/my-bar'
    | '/account/settings'
    | '/recipes/explore'
    | '/recipes/$slug/edit'
    | '/account/settings/'
    | '/recipes/'
    | '/recipes/$slug'
    | '/account/settings/drinks'
    | '/account/settings/general'
    | '/account/settings/recipes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/home'
    | '/login'
    | '/signup'
    | '/account/edit'
    | '/recipes'
    | '/recipes/new'
    | '/account'
    | '/my-bar'
    | '/account/settings'
    | '/recipes/explore'
    | '/recipes/$slug/edit'
    | '/recipes/$slug'
    | '/account/settings/drinks'
    | '/account/settings/general'
    | '/account/settings/recipes'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_app/home'
    | '/_auth/login'
    | '/_auth/signup'
    | '/_app/account/edit'
    | '/_app/recipes'
    | '/_app/recipes/_list'
    | '/_app/recipes/new'
    | '/_app/account/'
    | '/_app/my-bar/'
    | '/_app/account/settings'
    | '/_app/account/settings/_layout'
    | '/_app/recipes/_list/explore'
    | '/_app/recipes/$slug/edit'
    | '/_app/account/settings/'
    | '/_app/recipes/_list/'
    | '/_app/recipes/$slug/'
    | '/_app/account/settings/_layout/drinks'
    | '/_app/account/settings/_layout/general'
    | '/_app/account/settings/_layout/recipes'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/_auth"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/home",
        "/_app/account/edit",
        "/_app/recipes",
        "/_app/account/",
        "/_app/my-bar/",
        "/_app/account/settings"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/signup"
      ]
    },
    "/_app/home": {
      "filePath": "_app/home.tsx",
      "parent": "/_app"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_auth/signup": {
      "filePath": "_auth/signup.tsx",
      "parent": "/_auth"
    },
    "/_app/account/edit": {
      "filePath": "_app/account/edit.tsx",
      "parent": "/_app"
    },
    "/_app/recipes": {
      "filePath": "_app/recipes",
      "parent": "/_app",
      "children": [
        "/_app/recipes/_list",
        "/_app/recipes/new",
        "/_app/recipes/$slug/edit",
        "/_app/recipes/$slug/"
      ]
    },
    "/_app/recipes/_list": {
      "filePath": "_app/recipes/_list.tsx",
      "parent": "/_app/recipes",
      "children": [
        "/_app/recipes/_list/explore",
        "/_app/recipes/_list/"
      ]
    },
    "/_app/recipes/new": {
      "filePath": "_app/recipes/new.lazy.tsx",
      "parent": "/_app/recipes"
    },
    "/_app/account/": {
      "filePath": "_app/account/index.tsx",
      "parent": "/_app"
    },
    "/_app/my-bar/": {
      "filePath": "_app/my-bar/index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/account/settings": {
      "filePath": "_app/account/settings",
      "parent": "/_app",
      "children": [
        "/_app/account/settings/_layout",
        "/_app/account/settings/"
      ]
    },
    "/_app/account/settings/_layout": {
      "filePath": "_app/account/settings/_layout.tsx",
      "parent": "/_app/account/settings",
      "children": [
        "/_app/account/settings/_layout/drinks",
        "/_app/account/settings/_layout/general",
        "/_app/account/settings/_layout/recipes"
      ]
    },
    "/_app/recipes/_list/explore": {
      "filePath": "_app/recipes/_list/explore.tsx",
      "parent": "/_app/recipes/_list"
    },
    "/_app/recipes/$slug/edit": {
      "filePath": "_app/recipes/$slug.edit.lazy.tsx",
      "parent": "/_app/recipes"
    },
    "/_app/account/settings/": {
      "filePath": "_app/account/settings/index.tsx",
      "parent": "/_app/account/settings"
    },
    "/_app/recipes/_list/": {
      "filePath": "_app/recipes/_list/index.tsx",
      "parent": "/_app/recipes/_list"
    },
    "/_app/recipes/$slug/": {
      "filePath": "_app/recipes/$slug.index.lazy.tsx",
      "parent": "/_app/recipes"
    },
    "/_app/account/settings/_layout/drinks": {
      "filePath": "_app/account/settings/_layout/drinks.tsx",
      "parent": "/_app/account/settings/_layout"
    },
    "/_app/account/settings/_layout/general": {
      "filePath": "_app/account/settings/_layout/general.tsx",
      "parent": "/_app/account/settings/_layout"
    },
    "/_app/account/settings/_layout/recipes": {
      "filePath": "_app/account/settings/_layout/recipes.tsx",
      "parent": "/_app/account/settings/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
